module.exports = __webpack_public_path__ + "media/jobs_page/heroimg_statejobs_mobile-44b8c063.jpg";